import { ListaCandidatos, ImageUrna } from './../lista-candidatos';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-urna',
  templateUrl: './urna.component.html',
  styleUrls: ['./urna.component.css']
})
export class UrnaComponent implements OnInit {
  public id:string;
  public nome:string;
  public cargo:string;
  public numero:string;
  public apelido:string;
  public partido:string;
  public foto:any;
  public numProc:string = '';
  private imUrna:string
  constructor(private route : ActivatedRoute )
{
  this.imUrna = new ImageUrna().imageB64;
}
  ngOnInit() {
    let id =this.route.snapshot.paramMap.get('id');
    if(id != null){
    let cand = new ListaCandidatos().getListById(id);
    this.id = cand.id.toUpperCase();
    this.nome = cand.nome.toUpperCase();
    this.cargo = cand.cargo.toUpperCase();
    this.numero = cand.numero.toUpperCase();
    this.apelido = cand.apelido.toUpperCase();
    this.partido = cand.partido.toUpperCase();
    this.foto = cand.foto;
    }else{
      this.id = "99999";
      this.nome = "SEM CANDIDATO";
      this.cargo = "---";
      this.numero = "DIGITE O NUMERO";
      this.apelido = "---";
      this.partido = "---";
    }
  }
btnBranco(){

}
btnCancelar(){
  console.log('cancelou ' + this.numProc );
  this.id = '0';
  this.nome = null;
  this.cargo = null;
  this.numero = null;
  this.apelido = null;
  this.partido = null;
  this.foto = null;
  this.numProc='';
}
btnConfirmar(id:string){
console.log('votou'+id);
alert("Voto finalizado com Sucesso");
window.location.href = '/';
}
btnNumero(num:string){
  this.numProc += num;
  if(this.numProc != null){
    let cand = new ListaCandidatos().getListByNumero(this.numProc);
      if(cand != null){
        this.id = cand.id.toUpperCase();
        this.nome = cand.nome.toUpperCase();
        this.cargo = cand.cargo.toUpperCase();
        this.numero = cand.numero.toUpperCase();
        this.apelido = cand.apelido.toUpperCase();
        this.partido = cand.partido.toUpperCase();
        this.foto = cand.foto;
        //window.location.href = '/urna/'+this.numProc;
      }else{
        this.numero = this.numProc;
      }
    }else{
      this.id = "99999";
      this.nome = "SEM CANDIDATO";
      this.cargo = "---";
      this.numero = "---";
      this.apelido = "---";
      this.partido = "---";
    }
}
}
